
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Monthlybushireserviceinpune() {



    const cardData =
    {
        keyword: 'Monthly Bus Hire Service in Pune',
        heading: 'Amruta Travels: Monthly Bus Hire Service in Pune',
        headingDescription: 'Amruta Travels offers Monthly Bus Hire Service in Pune, providing reliable and cost-effective transportation solutions tailored for businesses, educational institutions, and organizations requiring regular travel arrangements. Whether it is for employee commuting, school transportation, or routine group travel, our well-maintained fleet ensures a comfortable and punctual journey throughout the month. Choose from a variety of buses, including 35, 36, 40, 47, 54, and 55-seater options, to suit your specific needs. With experienced drivers, flexible contracts, competitive pricing, and 24/7 customer support, Amruta Travels makes your monthly transportation in Pune seamless and stress-free. Book your monthly bus service with Amruta Travels today and experience consistent quality and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada served as the seat of the Peshwas of the Maratha Empire. This grand fortification, though partially destroyed by fire in 1828, still showcases its majestic gates, sturdy walls, and intricate architecture. The Delhi Darwaza, its main gate, is particularly notable. The site is steeped in history and legends, including tales of royal intrigue and the ghost of a young prince. An evening light and sound show narrates its rich past, making it a must-visit for history enthusiasts."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 by Sultan Aga Khan III, the palace is a significant landmark in India's freedom movement. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and his secretary Mahadev Desai during the Quit India Movement in 1942. The palace now houses a museum with photographs and personal artifacts of Gandhi, and the samadhis (memorials) of Kasturba Gandhi and Mahadev Desai. The serene gardens and Italian arches add to its architectural beauty."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the Sahyadri Hills, Sinhagad Fort is approximately 35 km from Pune. Known for the historic Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers panoramic views of the surrounding region. It's a popular trekking destination, especially during monsoons, and visitors often enjoy local delicacies like pithla-bhakri at the summit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this tranquil retreat is one of the world's largest meditation centers. Founded by spiritual leader Osho, the resort offers a blend of traditional and contemporary meditation techniques, wellness programs, and therapies. The lush gardens, serene ambiance, and international community make it a haven for those seeking inner peace and rejuvenation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple is dedicated to Lord Shiva. Carved from a single basalt rock, it features a circular Nandi mandapa and intricately designed pillars. Despite being amidst the bustling city, the temple offers a peaceful retreat and stands as a testament to ancient Indian rock-cut architecture."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses over 20,000 artifacts collected by Dr. Dinkar G. Kelkar in memory of his son. The collection includes musical instruments, paintings, sculptures, and everyday objects from the 18th and 19th centuries, offering a glimpse into India's rich cultural heritage. The museum's architecture, resembling a traditional Rajasthani mansion, adds to its charm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated on the Mutha River, Khadakwasla Dam is a popular spot for picnics and evening outings. The dam's vicinity offers scenic views, especially during monsoons when the reservoir is full. The area is also known for local street food vendors serving snacks like corn on the cob and bhel puri."
  },
  {
    "title": "Fergusson College Road",
    "description": "A bustling street in Pune, Fergusson College Road is lined with cafes, bookstores, boutiques, and eateries. It's a favorite hangout spot for students and youngsters, offering a vibrant mix of shopping and culinary experiences. The street comes alive in the evenings, reflecting the city's youthful energy."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is associated with the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and paintings depicting significant events from Shivaji's life. Its red-colored walls and historical significance make it a notable landmark in Pune."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by the Korakuen Garden in Okayama, Japan, this beautifully landscaped garden spans over 10 acres. It features manicured lawns, flowing streams, bridges, and a variety of flora. The garden offers a serene environment, ideal for leisurely walks and photography."
  }
],



  "services": [
    {
      "name": "35, 36, 40, 54, 55 Seater Bus Hire in Pune",
      "description": "Amruta Travels offers a wide range of large-capacity buses including 35, 36, 40, 54, and 55 seaters for hire in Pune. These buses are ideal for group tours, weddings, school outings, and corporate events. All vehicles come with AC, push-back seating, ample luggage space, and experienced drivers to ensure a smooth and safe journey."
    },
    {
      "name": "35, 36, 40, 47, 54, 55 Seater Company Bus Rental Service In Pune",
      "description": "Looking for reliable company bus rental services in Pune? Amruta Travels provides dedicated corporate transport solutions with seating options from 35 to 55 seats. We cater to daily employee pickups, corporate outings, and industrial shuttle services, ensuring punctuality and professionalism."
    },
    {
      "name": "Bus On Rent in Pune - Amruta Travels",
      "description": "Amruta Travels is your go-to provider for all types of buses on rent in Pune. Whether you need a mini bus for a family function or a large coach for a school or corporate trip, we offer flexible rental packages, professional drivers, and high standards of service across the city."
    },
    {
      "name": "Monthly Bus Hire For Corporate Employees",
      "description": "Amruta Travels offers cost-effective monthly bus hire services for transporting corporate employees across Pune and PCMC. With fixed monthly pricing, customizable routes, and timely service, we help companies streamline employee commute while ensuring safety and comfort."
    },
    {
      "name": "35 Seater Bharat Benz Bus on Rent",
      "description": "Travel in style with our 35-seater Bharat Benz buses, perfect for both short and long-distance trips. These buses offer modern interiors, smooth suspension, air-conditioning, and a premium travel experience for weddings, events, and tours across Maharashtra."
    },
    {
      "name": "Luxury Bus On Rent in Pune",
      "description": "Amruta Travels provides luxury buses for hire in Pune for those seeking top-tier comfort and amenities. These buses come equipped with AC, plush seating, entertainment systems, and ample space, making them ideal for high-end events, VIP transport, and executive group travel."
    },
    {
      "name": "57 Seater AC Bharat Benz on Rent in Pune",
      "description": "Need to transport a large group? Our 57-seater AC Bharat Benz buses are perfect for school excursions, pilgrimage tours, or large corporate movements. They offer high seating capacity, strong build, modern amenities, and are operated by experienced and courteous drivers."
    },
    {
      "name": "Monthly Bus On Rent in Kharadi IT Park",
      "description": "Amruta Travels offers monthly bus rental services specifically tailored for companies in Kharadi IT Park. With timely pickups, professional drivers, and comfortable seating, our service helps tech companies and corporate parks ensure hassle-free employee transport daily."
    }
  ],
  "tableData": [
    ["35, 36, 40, 54, 55 Seater Bus Hire in Pune", "35, 36, 40, 47, 54, 55 Seater Company Bus Rental Service In Pune"],
    ["Bus On Rent in Pune - Amruta Travels", "Monthly Bus Hire For Corporate Employees"],
    ["35 Seater Bharat Benz Bus on Rent", "Luxury Bus On Rent in Pune"],
    ["57 Seater AC Bharat Benz on Rent in Pune", "Monthly Bus On Rent in Kharadi IT Park"]
  ],

"whychoose": [
  {
    "WhyChooseheading": "Reliable Monthly Bus Hire Service in Pune for Consistent Travel Needs",
    "WhyChoosedescription": "Amruta Travels offers dependable Monthly Bus Hire Service in Pune tailored for businesses, schools, colleges, factories, and organizations that need regular group transportation. Whether you need daily staff pick-ups, student commutes, or scheduled shuttle services, we provide cost-effective and consistent transport solutions with professional service and reliable scheduling."
  },
  {
    "WhyChooseheading": "Wide Range of Bus Options for Any Group Size",
    "WhyChoosedescription": "We offer a fleet of well-maintained buses including 17, 20, 32, 35, 40, 45, and 50-seater vehicles, available in both AC and Non-AC variants. Our monthly rental plans can be customized based on your passenger count, route, and travel frequency, making them ideal for schools, IT parks, factories, and residential societies."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Educational, and Industrial Use",
    "WhyChoosedescription": "Our monthly bus hire service is ideal for companies needing employee transport, educational institutions arranging daily student shuttles, and factories requiring worker transport across shifts. We adapt to your operational hours and routing needs, ensuring punctual, safe, and comfortable daily commutes for your team."
  },
  {
    "WhyChooseheading": "Professional Drivers and Fixed Route Management",
    "WhyChoosedescription": "Our drivers are trained, uniformed, and punctual—committed to providing courteous service every day. With proper knowledge of Pune’s traffic and optimal routing, we help manage fixed pickup/drop schedules and respond swiftly to route or timing adjustments as needed, ensuring smooth transport management."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Monthly Pricing",
    "WhyChoosedescription": "Our pricing structure is flexible and cost-effective, tailored to meet monthly travel requirements while keeping your budget in check. We offer flat monthly rates based on kilometers, hours, or number of trips—with no hidden costs. Packages can include fuel, driver salary, maintenance, and more, giving you predictable expenses every month."
  },
  {
    "WhyChooseheading": "Maintenance-Free Experience with Full Operational Support",
    "WhyChoosedescription": "Amruta Travels handles all aspects of vehicle maintenance, insurance, cleanliness, and breakdown support. You get a worry-free service without the burden of fleet ownership or upkeep. In case of vehicle issues, we provide immediate backup solutions to ensure zero disruption in daily operations."
  },
  {
    "WhyChooseheading": "Custom Route Planning and Schedule Optimization",
    "WhyChoosedescription": "We help you plan the most efficient pickup and drop routes based on location clusters, timing constraints, and traffic conditions. Our transport coordinators assist in mapping out optimal schedules to reduce travel time while maximizing passenger convenience—especially helpful for businesses with multiple shift timings."
  },
  {
    "WhyChooseheading": "Dedicated Account Manager and 24/7 Support",
    "WhyChoosedescription": "For all monthly contracts, we assign a dedicated account manager to handle scheduling, updates, reporting, and support. Whether it's modifying a route, changing a bus, or handling attendance reports, we offer responsive and professional service backed by 24/7 customer assistance via phone and WhatsApp."
  }
]















    }

const faqData = [
  {
    question: 'What is a monthly bus hire service in Pune?',
    answer: 'Our monthly bus hire service in Pune allows you to rent a bus on a recurring basis for daily travel needs such as employee transport, school/college trips, or long-term corporate assignments. It’s ideal for consistent, reliable group transport.',
  },
  {
    question: 'Who can benefit from monthly bus hire?',
    answer: 'Monthly bus rental is ideal for IT companies, manufacturing units, schools, colleges, and event companies that need regular transportation services for staff, students, or teams in and around Pune.',
  },
  {
    question: 'What types of buses are available for monthly hire?',
    answer: 'We offer a wide fleet for monthly hire, including 32, 35, 40, 45, and 50-seater buses. You can choose AC or non-AC variants, depending on your budget and comfort requirements.',
  },
  {
    question: 'Is the monthly rental customizable based on timing and routes?',
    answer: 'Yes, we provide fully customizable monthly hire plans with fixed or flexible routes, specific timing slots, and multiple pickup and drop-off points based on your needs.',
  },
  {
    question: 'Are drivers included in the monthly bus rental service?',
    answer: 'Yes, all monthly bus hire plans include experienced, uniformed, and licensed drivers. We ensure punctuality, safety, and professionalism throughout the service period.',
  },
  {
    question: 'What is the cost of monthly bus hire in Pune?',
    answer: 'The cost depends on the number of days, bus type, distance covered daily, and additional services (like air conditioning, onboard support, etc.). Contact us for a personalized and transparent quote.',
  },
  {
    question: 'Can I track the bus during operation?',
    answer: 'Yes, GPS tracking is available on request, ensuring real-time visibility of your bus during daily operations — especially useful for employee or student safety.',
  },
  {
    question: 'Do you offer backup support in case of breakdowns?',
    answer: 'Absolutely. We have standby vehicles and 24/7 support to ensure uninterrupted service. In case of any issue, a replacement bus is dispatched immediately.',
  },
  {
    question: 'Why choose Amruta Travels for monthly bus hire in Pune?',
    answer: 'Amruta Travels offers reliable, cost-effective, and well-managed monthly bus rental services with regular maintenance, clean buses, professional drivers, and a client-first approach.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Nikhil Jadhav',
    role: 'Admin Manager, IT Company in Pune',
    text: 'We’ve been using Amruta Travels for our employee transport on a monthly basis for over a year now. Their service is prompt, professional, and hassle-free. Highly dependable!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sheetal More',
    role: 'Principal, Private School in Pune',
    text: 'We hired a 40-seater bus for school transportation on a monthly basis. Amruta Travels has been incredibly cooperative and punctual. The buses are always clean, and the driver is very courteous.',
    rating: 5,
  },
];




























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Bus Hire Service in Pune",
  "image": "https://bushireinpune.com/assets/images/monthly-bus-hire-service.jpg",
  "description": "Amruta Travels offers Monthly Bus Hire Services in Pune, perfect for corporate employees, school trips, and group travel. Choose from a wide range of buses, including 35, 36, 40, 47, 54, and 55-seater options. We provide luxury AC Bharat Benz buses and regular buses for daily or monthly rentals, with services available in locations like Kharadi IT Park.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "13100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "35000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/monthly-bus-hire-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Monthly Bus Hire Service in Pune | Corporate Bus Rentals | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent monthly buses for corporate employees and group travel in Pune. We offer 35, 36, 40, 47, 54, 55-seater buses including luxury AC Bharat Benz. Available in Kharadi IT Park and more locations." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlybushireserviceinpune;